import { FunctionComponent } from 'react'

import { IconProps } from '@fairhq/common/lib/components/atoms/icons/types'

export const Vote: FunctionComponent<IconProps> = ({
  fill = 'currentColor',
  width = '24',
  height = '25',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5525 15.8929C19.5525 15.8297 19.3631 15.7034 19.2367 15.7034H17.6578V17.9139H18.0999C18.2894 17.9139 18.4789 17.9139 18.6052 18.1034C18.7315 18.2297 18.7946 18.4192 18.7946 18.5455C18.7946 18.9244 18.4789 19.1771 18.1631 19.1771H5.91043C5.72095 19.1771 5.53148 19.1771 5.40517 19.0507C5.32673 18.9919 5.26306 18.9156 5.21921 18.8279C5.17536 18.7402 5.15253 18.6435 5.15253 18.5455C5.15253 18.1665 5.46832 17.9139 5.91043 17.9139H6.35253V15.7034H5.02622C4.8999 15.7034 4.77359 15.8297 4.71043 15.8929L3.51043 21.0718L3.57359 21.3244L3.82622 21.3876H20.2473C20.4367 21.3876 20.5631 21.1981 20.5631 21.0718L19.5525 15.8929Z"
      fill={fill}
    />
    <path
      d="M16.142 18.2297V10.9665C16.142 10.7771 16.0157 10.6508 15.8894 10.6508H12.542L12.7315 10.9665C12.921 11.5981 12.8578 12.2297 12.542 12.735C11.9104 13.8086 10.6473 14.2507 9.57359 13.7455L7.93148 12.8613V18.2297H16.142Z"
      fill={fill}
    />
    <path
      d="M6.92095 10.8402L9.82622 12.4192C10.2683 12.6718 10.7104 12.4823 10.8999 12.1034C11.0262 11.9139 11.0894 11.6613 10.9631 11.4718C10.9631 11.2192 10.7736 11.0297 10.521 10.9665L8.24727 9.70338L8.37359 9.64022C8.56306 9.38759 8.87885 9.26128 9.13148 9.26128H13.6157L12.2262 7.30338C11.7841 6.6718 11.0262 6.2297 10.3315 6.2297H8.87885C8.37359 6.2297 7.93148 5.97707 7.55253 5.59812L6.03674 4.33496H5.72095L3.51043 7.05075C3.38411 7.17707 3.44727 7.36654 3.51043 7.49286L4.83674 8.6297C5.08938 8.94549 5.34201 9.26128 5.46832 9.64022C5.72095 10.2718 6.22622 10.7139 6.8578 10.9034L6.92095 10.8402Z"
      fill={fill}
    />
  </svg>
)
